import { useState, useEffect } from 'react';

const defaultOptions = {};
/**
 *
 * useInput Hook
 *
 * Handles an input's value and onChange props internally to
 * make text input creation process easier
 *
 * @param {any} [initialValue=""] Initial value of the input
 * @param {Options} [opts={}] Options object
 * @returns {InputHandler} Input handler with value and onChange
 */
function useInput(initialValue = "", opts = defaultOptions) {
    const [value, setValue] = useState(initialValue);
    function onChange(e) {
        const newValue = e.target.value;
        let shouldUpdate = true;
        if (typeof opts.validate === "function") {
            shouldUpdate = opts.validate(newValue, value);
        }
        if (shouldUpdate) {
            setValue(newValue);
        }
    }
    //sync with default value
    useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);
    const handler = {
        value,
        onChange
    };
    return handler;
}

export default useInput;
//# sourceMappingURL=index.esm.js.map
